import { render, staticRenderFns } from "./ProductLocalCustomers.vue?vue&type=template&id=a5f854a2&"
import script from "./ProductLocalCustomers.vue?vue&type=script&lang=js&"
export * from "./ProductLocalCustomers.vue?vue&type=script&lang=js&"
import style0 from "./ProductLocalCustomers.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5f854a2')) {
      api.createRecord('a5f854a2', component.options)
    } else {
      api.reload('a5f854a2', component.options)
    }
    module.hot.accept("./ProductLocalCustomers.vue?vue&type=template&id=a5f854a2&", function () {
      api.rerender('a5f854a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ProductLocalCustomers.vue"
export default component.exports